@if (!freemiumPremiumFeatureEnabled) {

    <div *ngIf="!noModalContext" mat-dialog-title>
        <h2>{{dataInjected.title | translate}}</h2>
        <button class="close"
                (click)="close()"
                aria-label="Close dialog">
            <mat-icon svgIcon="cross"></mat-icon>
        </button>
    </div>

    <mat-dialog-content fusePerfectScrollbar>
        <ng-container *ngFor="let row of dataInjected.list; let index = index">
            <button [attr.data-e2e]="'button_list_item_' + index" [disabled]="isBtnDisabled(row)" mat-raised-button (click)="selectedItem(row, index)">
                {{row.label | translate}}
            </button>
        </ng-container>
    </mat-dialog-content>

} @else {
    <header class="button-list-dialog__header">
        <div class="button-list-dialog__heading-group">
            <h2 class="button-list-dialog__title">{{'freemium.learners_ready' | translate }}</h2>
            <div class="button-list-dialog__subtitle">{{'freemium.session_in_class_ready' | translate }}</div>
        </div>
        <div class="button-list-dialog__heading-decoration"
             aria-hidden="true"></div>
    </header>

    <div class="button-list-dialog__content">
        <ul class="button-list-dialog__session-list">
            @for (session of dataInjected.list; track session.id; let i = $index) {
                <li class="button-list-dialog__session-item">
                    <button class="button-list-dialog__start-session-bouton"
                            [attr.premium]="!session.isEnabledForFreemium"
                            [disabled]="isBtnDisabled(session)"
                            (click)="selectedItem(session)">
                        <span>{{ session.label }}</span>
                        @if (!session.isEnabledForFreemium) {
                            <div class="button-list-dialog__premium-tag">
                                <mat-icon svgIcon="button-list-dialog__premium-session"></mat-icon>
                                <span>{{'freemium.premium' | translate }}</span>
                            </div>
                        } @else {
                            <mat-icon svgIcon="button-list-dialog__start-session"></mat-icon>
                        }
                    </button>
                </li>
            }
        </ul>
    </div>
}


